export const AlertCircleIcon = 'alert-circle';
export const AlertTriangleIcon = 'alert-triangle';
export const ArrowDownIcon = 'arrow-down';
export const CalendarIcon = 'calendar';
export const ChevronRightIcon = 'chevron-right';
export const DeleteIcon = 'delete';
export const InfoIcon = 'info';
export const PlusIcon = 'plus';
export const ProductIcon = 'product';
export const QuestionCircleIcon = 'question-circle';
export const RefreshIcon = 'refresh';
export const SearchIcon = 'search';
export const XIcon = 'x';
